import type { DeepReadonly } from "@itandi/itandi-bb-ui";
import type { ReactNode } from "react";

type Props = DeepReadonly<{
	children: ReactNode;
}>;

export function TableBody({ children }: Props) {
	return <tbody>{children}</tbody>;
}
